import Request from '@/plugins/request'

export function getWechatTemplates(params) {
  return Request.get('wechat-templates', { params })
}

export function getSceneTypes() {
  return Request.get('wechat-templates/scene-type')
}

export function createWechatTemplate() {
  return Request.get(`wechat-templates/create`)
}

export function storeWechatTemplate(data) {
  return Request.post('wechat-templates', data)
}

export function updateWechatTemplate(id, data) {
  return Request.put(`wechat-templates/${id}`, data)
}

export function editWechatTemplate(id) {
  return Request.get(`wechat-templates/${id}/edit`)
}

export function destroyWechatTemplate(id) {
  return Request.delete(`wechat-templates/${id}`)
}
